<div class="error">
  <div class="error_body">
      <h2 class="title">Error {{code}}</h2>
      <div class="content">
        <p class="txt" [innerHTML]="message">{{message}}</p>
      </div>
    </div>
</div>
